import { toast } from '../components/ToastManager';
import { getExecutionLogData } from '../redux/actions/General/AuthAction';

export const handleExecutionLog = async (dispatch, logNumber) => {
    if (!logNumber) return;
    try {
        const res = await dispatch(getExecutionLogData({ id: logNumber }));
        const data = res?.data || res;
        const details = Array.isArray(data)
            ? data.flatMap(item => item.details || [])
            : (data?.details || []);

        let hasError = false;
        if (details.length === 1) {
            let hasMessage = false;

            details.forEach((item) => {
                const message = item?.message;
                const type = item?.message_type?.toLowerCase();

                if (!message) return;
                hasMessage = true;

                switch (type) {
                    case 'error':
                        hasError = true;
                        toast.showToast({ __type: 'execution_log', data }, { type: 'error', duration: 12000, pinned: false });
                        break;
                    case 'warning':
                        toast.showWarning(message);
                        break;
                    case 'info':
                    case 'success':
                        toast.showSuccess(message);
                        break;
                    default:
                        toast.showInfo(message);
                }
            });
            if (!hasMessage) {
                toast.showSuccess('Operation completed successfully');
            }
        }
        else {
            hasError = details.some(d => d.message_type?.toLowerCase() === 'error');

            toast.showToast({ __type: 'execution_log', data }, {
                type: hasError ? 'error' : 'info',
                duration: 12000,
                pinned: false,
            });
        }
        return { hasError };

    } catch (err) {
        toast.showError('Failed to fetch execution logs');
        return { hasError: true };
    }
};